<div class="blackout-period-list-container" data-testid="blackout-period-list-container">

  <!-- List Header -->
  <div class="flex justify-content-between align-items-center w-full px-4 py-3 border-bottom-1 surface-border"
    data-testid="blackout-period-list-header">
    <div class="flex align-items-center gap-3">
      <i class="pi pi-calendar-times text-xl text-primary"></i>
      <div>
        <h3 class="m-0 text-base font-semibold text-900" data-testid="blackout-period-list-title">
          {{ 'CAMPAIGN.BLACKOUT.MANAGE' | translate }}
        </h3>
        @if (loading | async) {
          <p-skeleton width="80px" height="14px" styleClass="mt-1" />
        } @else {
          <p class="text-500 text-xs mt-1 mb-0"
            [innerHTML]="'CAMPAIGN.BLACKOUT.TOTAL_REC' | translate : { count: totalRecordLength.value.totalItems }"
            data-testid="blackout-period-total-count">
          </p>
        }
      </div>
    </div>
    <div class="flex align-items-center gap-2">
      <p-button
        icon="pi pi-plus"
        [label]="'CAMPAIGN.BLACKOUT.ADD' | translate"
        size="small"
        (onClick)="openCreate()"
        aria-label="add-blackout-period-button"
        data-testid="add-blackout-period-button" />
      <button
        type="button"
        class="p-ripple p-button p-component p-button-icon-only p-button-secondary p-button-rounded p-button-text"
        (click)="closeDialog()"
        style="cursor: pointer;"
        aria-label="close-blackout-period-list-button"
        data-testid="close-blackout-period-list-button">
        <span class="p-button-icon pi pi-times"></span>
      </button>
    </div>
  </div>

  <!-- Filter Bar -->
  <div class="flex align-items-center gap-2 px-3 py-2 surface-50 border-bottom-1 surface-border"
    data-testid="blackout-period-filter-bar">
    <i class="pi pi-filter text-500 text-sm flex-shrink-0"></i>
    <p-select
      [options]="typeFilterOptions"
      optionLabel="label"
      optionValue="value"
      [ngModel]="filterType()"
      (onChange)="onTypeFilterChange($event.value)"
      inputStyleClass="w-full text-sm"
      class="flex-1 text-sm"
      appendTo="body"
      aria-label="blackout-type-filter"
      data-testid="blackout-type-filter" />
    <p-select
      [options]="statusFilterOptions"
      optionLabel="label"
      optionValue="value"
      [ngModel]="filterStatus()"
      (onChange)="onStatusFilterChange($event.value)"
      inputStyleClass="w-full text-sm"
      class="flex-1 text-sm"
      appendTo="body"
      aria-label="blackout-status-filter"
      data-testid="blackout-status-filter" />
    @if (hasActiveFilters) {
      <p-button
        icon="pi pi-times"
        [label]="'CAMPAIGN.BLACKOUT.CLEAR_FILTERS' | translate"
        severity="secondary"
        [text]="true"
        size="small"
        (onClick)="clearFilters()"
        aria-label="clear-blackout-filters-button"
        data-testid="clear-blackout-filters-button" />
    }
  </div>

  <!-- Skeleton loading -->
  @if (loading | async) {
    <div class="px-4 py-3" data-testid="blackout-period-list-skeleton">
      <p-table [value]="[1, 2, 3, 4, 5]">
        <ng-template pTemplate="header">
          <tr>
            @for (col of [1, 2, 3, 4, 5, 6]; track col) {
              <th><p-skeleton /></th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <tr>
            @for (col of [1, 2, 3, 4, 5, 6]; track col) {
              <td><p-skeleton /></td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <!-- Data Grid -->
    <app-data-grid
      [loading]="loading.value"
      [columnData]="tableData"
      [columns]="columns"
      [EmptyState]="emptyStateComponent$"
      [selectable]="selectAllData"
      [paginator]="false"
      [totalRecords]="totalRecordLength"
      (onAction)="onActionEvent($event)"
      [gridName]="'blackout-period-list'"
      data-testid="blackout-period-data-grid">
    </app-data-grid>
  }

</div>

<!-- Create / Edit Dialog -->
<blackout-period-create
  [visible]="showCreateDialog()"
  [activeConfig]="activeEditConfig()"
  (changed)="changedConfig()"
  (dialogClose)="closeCreate()"
  data-testid="blackout-period-create-dialog">
</blackout-period-create>
